@if (isLoading === false && results?.length === 0) {
  <p>
    Nothing found.
  </p>
}
@if (isLoading) {
  <p>
    <app-spinner [condition]="isLoading"></app-spinner>
  </p>
}
@if (results.length) {
  <table class="table table-bordered" [ngClass]="{ 'disabled': isLoading }">
    <tbody>
      @for (result of results; track $index) {
        <tr>
          <td class="mw-280 border-0 d-none d-md-block">
            <div class="row">
              <div class="col-md-4 pe-0 d-flex align-items-center">
                <img class="img-50 img-rounded" [src]="result.profile_picture || result.user?.profile_picture" alt="Source">
              </div>
              @if (result.source === 'twitter') {
                <div class="col-md-8 pl-lg-0">
                  @if (result.user?.mdb?._id) {
                    <span>
                      <a [routerLink]="'/stakeholder/' + result.user.mdb._id">{{result.user?.name}}</a>
                    </span>
                  }
                  @if (!result.user?.mdb?._id) {
                    <span>{{result.user?.name}}</span>
                  }
                  <br>
                    <a [href]="'https://x.com/' + result.user?.username" target="_blank" class="text-break small">
                      &#64;{{result.user?.username}} <i class="fa fa-twitter"></i>
                    </a>
                  </div>
                }
                @if (result.source !== 'twitter') {
                  <div class="col-md-8 pl-lg-0">
                    <p class="m-0">{{result.user?.name}}</p>
                    @if (result.idLegislatura) {
                      <p class="m-0 small">Legislatura {{result.idLegislatura}}a</p>
                    }
                    @if (result.idSeduta) {
                      <p class="m-0 small">Seduta n. {{result.idSeduta.replace('0', '')}}</p>
                    }
                    @if (result.idCommissione?.length > 2) {
                      <p class="m-0 small">Commissione {{(result.idCommissione | idcommissione2roman)}}</p>
                    }
                    <p class="m-0 small">{{result.tipoDoc}}</p>
                  </div>
                }
              </div>
            </td>
            <td>
              <div class="pb-2 d-flex d-md-none">
                <div class="pe-2 align-self-center">
                  <img class="img-50 img-rounded" [src]="result.profile_picture || result.user?.profile_picture" alt="Source">
                </div>
                @if (result.source === 'twitter') {
                  <div class="ps-lg-0 align-self-center">
                    @if (result.user?.mdb?._id) {
                      <span>
                        <a [routerLink]="'/stakeholder/' + result.user.mdb._id">{{result.user?.name}}</a>
                      </span>
                    }
                    @if (!result.user?.mdb?._id) {
                      <span>{{result.user?.name}}</span>
                    }
                    <br>
                      <a [href]="'https://x.com/' + result.user?.username" target="_blank" class="text-break small">
                        &#64;{{result.user?.username}} <i class="fa fa-twitter"></i>
                      </a>
                    </div>
                  }
                  @if (result.source !== 'twitter') {
                    <div class="ps-lg-0">
                      <p class="m-0">{{result.user?.name}}</p>
                      @if (result.idLegislatura) {
                        <p class="m-0 small">Legislatura {{result.idLegislatura}}a</p>
                      }
                      @if (result.idSeduta) {
                        <p class="m-0 small">Seduta n. {{result.idSeduta.replace('0', '')}}</p>
                      }
                      @if (result.idCommissione?.length > 2) {
                        <p class="m-0 small">Commissione {{(result.idCommissione | idcommissione2roman)}}</p>
                      }
                      <p class="m-0 small">{{result.tipoDoc}}</p>
                    </div>
                  }
                </div>
                @if (result.source === 'twitter') {
                  <p class="mb-0" [innerHTML]="result.text | linkify"></p>
                }
                @if (result.source !== 'twitter') {
                  <p class="mb-0">
                    @for (snippet of result.text; track $index) {
                      <span [innerHTML]="snippet + ' [...] '"></span>
                    }
                  </p>
                }
                <app-delete-btn-admin class="float-end" (click)="deleteItem(result.id)"></app-delete-btn-admin>
                <small class="float-end ms-1" data-bs-toggle="tooltip" data-placement="top" data-delay="350" title="View original post">
                  <a [href]="result.link" target="_blank">{{result.created_at | date:'MMM dd yyyy, h:mm a'}}</a>
                </small>
                @if (result.source === 'twitter' && isStakeholdersPage) {
                  <span class="float-end text-muted small me-2">
                    <i class="fa fa-signal ms-1"></i> {{result.metrics.impressions || 0}}
                    <i class="fa fa-comments ms-1"></i> {{result.metrics.quotes || 0}}
                    <i class="fa fa-retweet ms-1"></i> {{result.metrics.retweets || 0}}
                    <i class="fa fa-heart ms-1"></i> {{result.metrics.likes || 0}}
                  </span>
                }
                @if (result.source === 'twitter' && !isStakeholdersPage) {
                  <div class="btn-group float-end me-2 hide-print" [ngClass]="{ 'disabled': isLoadingSentiment }">
                    <button class="btn btn-sm" type="button" (click)="updateSentiment(result.id, 25)"
                      [ngClass]="{ 'btn-danger': result.sentiment === 25, 'btn-outline-danger': !result.sentiment || result.sentiment !== 25 }"
                      data-bs-toggle="tooltip" data-placement="top" data-delay="300" title="Set as negative sentiment">
                      <i class="fa fa-frown-o"></i>
                    </button>
                    <button class="btn btn-sm" type="button" (click)="updateSentiment(result.id, 50)"
                      [ngClass]="{ 'btn-warning': result.sentiment === 50, 'btn-outline-warning': !result.sentiment || result.sentiment !== 50 }"
                      data-bs-toggle="tooltip" data-placement="top" data-delay="300" title="Set as neutral sentiment">
                      <i class="fa fa-meh-o"></i>
                    </button>
                    <button class="btn btn-sm" type="button" (click)="updateSentiment(result.id, 75)"
                      [ngClass]="{ 'btn-success': result.sentiment === 75, 'btn-outline-success': !result.sentiment || result.sentiment !== 75 }"
                      data-bs-toggle="tooltip" data-placement="top" data-delay="300" title="Set as positive sentiment">
                      <i class="fa fa-smile-o"></i>
                    </button>
                  </div>
                }
              </td>
            </tr>
          }
        </tbody>
      </table>
    }